// extracted by mini-css-extract-plugin
module.exports = {"publisherSection":"Publisher_publisherSection__SXW5W"};